module.exports = __webpack_public_path__ + "static/media/Car-black.3cd5980f.svg";